import { MAX_VOLUME, MIN_VOLUME } from 'atds-player-layout/src/enums'
import storage from 'atds-player-layout/src/storage'

const AUTOPLAY_CLICKED = 'autoplay-clicked'

export const PlayerMuteMixin = {
  watch: {
    'playerState.mute': function (muted) {
      const player = this.playerInstance

      if (!player?.holderId) {
        return
      }

      const volume = muted
        ? MIN_VOLUME
        : storage.playerSettings[player.holderId]?.volume || MAX_VOLUME
      player.setVolume(volume)

      muted ? player.mute() : player.unMute()

      this.$store.commit('player/SET_AUTOPLAY', AUTOPLAY_CLICKED)
    }
  }
}
